import React, { useEffect } from 'react';
import '../css/loader.css';


const Loader = () => {
    return(
        <div className='load rounded-circle mx-auto'>

        </div>
);
};

export default Loader;
